/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { WDHImage } from '@demant/wdh';
import { withReactBootstrap } from '@demant/wdh-react-bootstrap';
import { triggerEvent } from '../../../../../../wdh-foundation/wdh';
var BlogPostApp = function BlogPostApp(_ref) {
  var settings = _ref.settings;
  useEffect(function () {
    triggerEvent('link-embed-code-detected');
  });
  var getImage = function getImage() {
    var imageData = settings.image;
    if (imageData != null) {
      return /*#__PURE__*/React.createElement("div", {
        className: "blog-image-component"
      }, /*#__PURE__*/React.createElement(WDHImage, {
        image: imageData.image
      }));
    }
    return null;
  };
  var getAuthor = function getAuthor() {
    var authorData = settings.author;
    if (authorData != null) {
      return /*#__PURE__*/React.createElement("div", {
        className: "blog-author",
        dangerouslySetInnerHTML: {
          __html: settings.author.html
        }
      });
    }
    return null;
  };
  var getDate = function getDate() {
    var dateData = settings.date;
    if (dateData != null) {
      return /*#__PURE__*/React.createElement("div", {
        className: "blog-date"
      }, " ", settings.date.text, " ");
      {
        ' ';
      }
    }
    return null;
  };
  var getReadingTime = function getReadingTime() {
    var readingData = settings.readingTime;
    if (readingData != null) {
      return /*#__PURE__*/React.createElement("div", {
        className: "blog-reading-time"
      }, settings.readingTime.html);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "blog"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-headline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-title"
  }, /*#__PURE__*/React.createElement("h1", null, settings.title.text)), getAuthor(), getDate(), getReadingTime())), getImage(), /*#__PURE__*/React.createElement("div", {
    className: "blog-content",
    dangerouslySetInnerHTML: {
      __html: settings.blogContent.html
    }
  })));
};
export default withReactBootstrap(BlogPostApp);